class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();
      }
    });

    // ✅ quando carrinho muda (ex: add-to-cart na PDP), atualiza e abre o drawer
    this.bindAutoOpenOnCartUpdate();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  bindAutoOpenOnCartUpdate() {
    if (!window.MinimogEvents || !window.MinimogTheme || !MinimogTheme.pubSubEvents) return;

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (evt) => {
      // não abre na página /cart
      if (MinimogSettings.templateName === "cart") return;
      if (!MinimogSettings.enable_cart_drawer) return;

      // sempre atualiza o drawer e abre (isso recupera o comportamento “original”)
      this.onCartDrawerUpdate(true);
      this.open();
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // ✅ classe para esconder Whats/vídeo via CSS
    document.body.classList.add("cart-drawer-open");

    this.classList.add("m-cart-drawer--active");
    requestAnimationFrame(() => {
      this.style.setProperty("--m-bg-opacity", "0.5");
      this.cartDrawerInner.style.setProperty("--translate-x", "0");
    });

    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add("prevent-scroll");

    // ✅ carrega recomendados toda vez que abrir (caso o container tenha sido re-renderizado)
    setTimeout(() => {
      try {
        loadCartDrawerRecommendations();
        bindCartDrawerRecommendationButtons();
      } catch (e) {}
    }, 50);
  }

  close() {
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");

      // ✅ remove classe do body para voltar Whats/vídeo
      document.body.classList.remove("cart-drawer-open");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement) return;

          if (section.block === "cart-items") {
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });

        // ✅ depois de re-render, rebind dos botões e recarrega recomendados
        try {
          loadCartDrawerRecommendations();
          bindCartDrawerRecommendationButtons();
        } catch (e) {}
      })
      .catch(console.error);

    this.getCart().then((cart) => {
      this.classList.toggle("m-cart--empty", cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : "";
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "[data-minimog-cart-items]", block: "cart-items" },
      { id: "cart-drawer", selector: "[data-minimog-cart-discounts]", block: "cart-footer" },
      { id: "cart-drawer", selector: "[data-cart-subtotal]", block: "cart-footer" },
      { id: "cart-drawer", selector: "[data-minimog-gift-wrapping]", block: "cart-footer" },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-items]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-discounts]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-cart-subtotal]" },
      { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-gift-wrapping]" },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);

/* ===========================
   RECOMMENDATIONS LOADING
=========================== */

function loadCartDrawerRecommendations() {
  var container = document.querySelector('[data-drawer-recommendations]');
  if (!container) return;

  var productId = container.getAttribute("data-product-id");
  var sectionId = container.getAttribute("data-section-id");
  if (!productId || !sectionId) return;

  fetch("/recommendations/products?product_id=" + productId + "&section_id=" + sectionId)
    .then(function (response) {
      return response.text();
    })
    .then(function (text) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(text, "text/html");
      var section = doc.querySelector(".shopify-section");

      if (section && section.innerHTML.trim().length > 0) {
        container.innerHTML = section.innerHTML;
        bindCartDrawerRecommendationButtons(container);
      } else {
        container.remove();
      }
    })
    .catch(function (err) {
      console.error("Erro ao carregar recomendações:", err);
    });
}

/**
 * Botão "Adicionar" dos recomendados
 */
function bindCartDrawerRecommendationButtons(root) {
  var scope = root || document;
  var buttons = scope.querySelectorAll(".m-cart-reco-btn");

  buttons.forEach(function (btn) {
    if (btn.dataset.recoBound === "true") return;
    btn.dataset.recoBound = "true";

    btn.addEventListener("click", function (event) {
      event.preventDefault();

      var item = btn.closest(".m-cart-drawer__recommendations-item");
      var select = item ? item.querySelector("[data-reco-variant-select]") : null;

      var variantId = null;
      if (select && select.value) variantId = select.value;
      else variantId = btn.getAttribute("data-reco-variant-id");

      if (!variantId) return;
      if (btn.disabled) return;
      btn.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          // ✅ atualiza e abre
          var drawer = document.querySelector("m-cart-drawer");
          if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
            drawer.onCartDrawerUpdate(true);
          }
          if (drawer && typeof drawer.open === "function") {
            drawer.open();
          }
        })
        .catch(function (err) {
          console.error("Erro ao adicionar item recomendado:", err);
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  loadCartDrawerRecommendations();
  bindCartDrawerRecommendationButtons();
});